/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsDimensions } from './FxIdDomainSettingsDimensions';
import {
    instanceOfFxIdDomainSettingsDimensions,
    FxIdDomainSettingsDimensionsFromJSON,
    FxIdDomainSettingsDimensionsFromJSONTyped,
    FxIdDomainSettingsDimensionsToJSON,
} from './FxIdDomainSettingsDimensions';

/**
 * @type FxIdDomainSettingsPresentationOptionsMinRatio
 * Минимальное соотношение сторон
 * @export
 */
export type FxIdDomainSettingsPresentationOptionsMinRatio = FxIdDomainSettingsDimensions;

export function FxIdDomainSettingsPresentationOptionsMinRatioFromJSON(json: any): FxIdDomainSettingsPresentationOptionsMinRatio {
    return FxIdDomainSettingsPresentationOptionsMinRatioFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPresentationOptionsMinRatioFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPresentationOptionsMinRatio {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsDimensions(json)) {
        return FxIdDomainSettingsDimensionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPresentationOptionsMinRatioToJSON(json: any): any {
    return FxIdDomainSettingsPresentationOptionsMinRatioToJSONTyped(json, false);
}

export function FxIdDomainSettingsPresentationOptionsMinRatioToJSONTyped(value?: FxIdDomainSettingsPresentationOptionsMinRatio | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsDimensions(value)) {
        return FxIdDomainSettingsDimensionsToJSON(value as FxIdDomainSettingsDimensions);
    }

    return {};
}

